

    <div id="layoutZoomPan" class="layoutZoomPan">
      <figure>
        <img src="{{getLayoutImagePath()}}"
             onError="this.src=''; this.className='img-default se-icons se-icon-action_picture';">
      </figure>
    </div>
